import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const SequenceSingleSkeletonView = () => (
  <>
    {new Array(2).fill('').map((index) => (
      <div key={index} className="sequence-steps-skeleton mt-2">
        <SkeletonLoading width={90} height={24} />
        <div className="bs-ml-32 bs-mr-32 mt-2">
          <div className="d-flex align-items-center">
            <SkeletonLoading width={82} height={30} />
            <SkeletonLoading width={483} height={20} className="ml-2" />
          </div>
          <div className="sequence-steps-skeleton__steps">
            <SkeletonLoading height={64} className="w-100" />
            <SkeletonLoading height={64} className="w-100" />
            <SkeletonLoading width={123} height={24} className="mt-2" />
          </div>
        </div>
      </div>
    ))}
  </>
);
export default SequenceSingleSkeletonView;
